import React from 'react';

export function EnergyIconAFB() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.15 52.45">
            <defs>
                <style>
                    {`
                        .cls-1-b {
                            stroke-width: .82px;
                        }

                        .cls-1-b, .cls-2-b, .cls-3-b {
                            stroke: #231f20;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                        }

                        .cls-1-b, .cls-3-b {
                            fill: none;
                        }

                        .cls-4-b {
                            font-size: 18.42px;
                        }

                        .cls-4-b, .cls-5-b {
                            fill: #231f20;
                            font-family: Calibri-Bold, Calibri;
                            font-weight: 700;
                        }

                        .cls-5-b {
                            font-size: 10px;
                        }

                        .cls-2-b {
                            stroke-width: .5px;
                        }

                        .cls-2-b, .cls-6-b {
                            fill: #fff;
                        }

                        .cls-6-b, .cls-7-b {
                            stroke-width: 0px;
                        }

                        .cls-7-b {
                            fill: #bfd730;
                        }

                        .cls-3-b {
                            stroke-width: 1.07px;
                        }
                    `}
                </style>
            </defs>
            <g id="B">
                <rect className="cls-6-b" x="69.5" y=".73" width="21.33" height="49" />
                <polygon className="cls-7-b" points="22.62 .77 .29 25.06 22.62 49.35 71.62 49.35 71.62 .77 22.62 .77" />
                <path
                    className="cls-1-b"
                    d="M23.1.41h67.27c.2,0,.36.16.36.36v48.58c0,.2-.16.36-.36.36H23.1c-.1,0-.2-.04-.26-.12L.5,25.3c-.13-.14-.13-.35,0-.48L22.84.52c.07-.07.16-.12.26-.12Z"
                />
                <path
                    className="cls-2-b"
                    d="M53.52,30.76c0,.85-.11,1.63-.33,2.32s-.52,1.31-.9,1.84-.84.99-1.37,1.37-1.12.7-1.76.95c-.64.25-1.32.43-2.05.55-.73.12-1.54.18-2.43.18h-5.9c-.38,0-.69-.12-.95-.36s-.39-.63-.39-1.18V15.49c0-.54.13-.94.39-1.18s.57-.36.95-.36h5.58c1.36,0,2.51.12,3.46.37s1.74.62,2.39,1.12c.65.5,1.14,1.14,1.48,1.9s.52,1.67.52,2.71c0,.58-.07,1.13-.21,1.64-.14.51-.34.98-.6,1.4-.26.42-.59.79-.97,1.11-.38.32-.82.58-1.31.78.63.12,1.21.34,1.74.65.53.31,1,.71,1.39,1.2.4.49.71,1.06.94,1.72.23.66.34,1.39.34,2.21ZM47.68,20.65c0-.48-.07-.92-.21-1.3-.14-.38-.34-.7-.62-.96-.27-.25-.62-.45-1.04-.58-.42-.14-.98-.2-1.67-.2h-2.28v6.24h2.52c.65,0,1.17-.08,1.56-.25.39-.17.71-.4.97-.69.26-.29.45-.63.58-1.02.13-.39.19-.8.19-1.23ZM48.83,30.93c0-.56-.09-1.06-.26-1.5-.17-.44-.42-.81-.75-1.1-.33-.3-.76-.53-1.27-.69-.52-.16-1.18-.24-2.01-.24h-2.68v6.83h3.26c.63,0,1.16-.07,1.59-.21.43-.14.8-.35,1.12-.63.31-.28.56-.62.74-1.04.18-.42.27-.89.27-1.42Z"
                />
            </g>
            <g id="Layer_11" data-name="Layer 11">
                <g>
                    <line className="cls-3-b" x1="81.33" y1="30.37" x2="81.33" y2="20.01" />
                    <polyline className="cls-3-b" points="84.08 22.71 81.33 19.96 78.59 22.71" />
                </g>
                <text className="cls-4-b" transform="translate(76.62 45.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        F
                    </tspan>
                </text>
                <text className="cls-4-b" transform="translate(74.84 15.94) scale(1 1.01)">
                    <tspan x="0" y="0">
                        A
                    </tspan>
                </text>
                <text className="cls-5-b" transform="translate(83.5 9.24) scale(1 1.01)">
                    <tspan x="0" y="0">
                        +
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
